import { useEffect, useState } from "react";
import { withApollo } from "react-apollo";
import { get, sortBy } from "underscore";
import { HistoryItemContext } from "./context";
import HistoryItemDialog from "./HistoryItemDialog";
import { entryType, formTypes } from "../../../constants";
import ACTION_LOGS_DATA_MODEL from "../../../utils/constants/actionLogsDataModel";
import { historyConfigurationDetailsField } from "../log-sheet/log-sheet-history/HistoryLogSheetCellsInfoArray";

const HistoryItemWrapper = ({
  client,
  children,
  queryName,
  importFn,
  CellsInfoArray,
  title,
  dataTestId,
  addButtonLabel,
  disableStatus = false,
  type
}) => {
  const [open, setOpen] = useState(false);
  const [historyItem, setHistoryItem] = useState(null);
  const [item, setItem] = useState(null);
  const handleOpenHistoryContent = (theItem) => {
    setOpen(true);
    setItem(theItem);
  };
  const handleCloseHistoryContent = () => {
    setOpen(false);
    setItem(null);
  };

  useEffect(() => {
    const fetchHistory = async () => {
      if (item) {
        const data = await importFn({ ...item }, { client });
        setHistoryItem(sortBy(get(data, [queryName, "items"]) ?? [], "createdAt").reverse());
      }
    };

    fetchHistory();
  }, [item, client, importFn, queryName]);

  if (
    item?.equipmentDetails?.entryType === entryType.cluster &&
    CellsInfoArray.some((el) => el.label === ACTION_LOGS_DATA_MODEL.configurationDetails.value)
  ) {
    const indexOfConfigDetails = CellsInfoArray.findIndex(
      (el) => el.label === ACTION_LOGS_DATA_MODEL.configurationDetails.value
    );
    CellsInfoArray.splice(indexOfConfigDetails, 1);
  }

  if (type !== formTypes.RUN_LOG) {
    if (
      item?.equipmentDetails?.entryType !== entryType.cluster &&
      !CellsInfoArray.some((el) => el.label === ACTION_LOGS_DATA_MODEL.configurationDetails.value)
    ) {
      const indexOfConfigDetails = CellsInfoArray.findIndex(
        (el) => el.label === ACTION_LOGS_DATA_MODEL.softwareVerison.value
      );
      CellsInfoArray.splice(indexOfConfigDetails + 1, 0, historyConfigurationDetailsField);
    }
  }

  return (
    <HistoryItemContext.Provider
      value={{
        open,
        handleOpenHistoryContent,
        handleCloseHistoryContent,
        historyItem,
        item
      }}
    >
      {children}
      <HistoryItemDialog
        selectedItem={item}
        open={open}
        handleClose={handleCloseHistoryContent}
        CellsInfoArray={CellsInfoArray}
        title={title}
        dataTestId={dataTestId}
        addButtonLabel={addButtonLabel}
        disableStatus={disableStatus}
      />
    </HistoryItemContext.Provider>
  );
};

export default withApollo(HistoryItemWrapper);
